import { IFilterItemV2 } from "#src/commonV2/Table/Filter/types";

import i18next from "i18next";
import { MemberRoleEnum } from "./enum";
import { WorkspaceMemberRoleValue } from "./value";

export const memberRoleItems: IFilterItemV2[] = [
  {
    key: MemberRoleEnum.MEMBER,
    value: WorkspaceMemberRoleValue.MEMBER,
    getLabel: () => i18next.t("filter.memberRole.member"),
  },
  {
    key: MemberRoleEnum.ADMIN,
    value: WorkspaceMemberRoleValue.ADMIN,
    getLabel: () => i18next.t("filter.memberRole.admin"),
  },
  {
    key: MemberRoleEnum.OWNER,
    value: WorkspaceMemberRoleValue.OWNER,
    getLabel: () => i18next.t("filter.memberRole.owner"),
  },
];
